module.exports = __webpack_public_path__ + "static/img/yy_zhibo.ac54629.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yy_zhibo.png
// module id = /9s2
// module chunks = 1